import { urlForArticle } from '_utils/articles';
import { urlFor } from '_utils/images';
import { Button, Typography } from 'antd';
import * as React from 'react';
import { useState } from 'react';
const { Paragraph } = Typography;

const COTY2024WinnerCard = ({winner}) => {
  const [ellipsis, setEllipsis] = useState(true);

  let awardTitle = winner.segment ? winner.segment.title : "";
  awardTitle += winner.category.title === "Segment Outperformers" ? "" : " " + winner.category.title;

  const badge = winner.badge ? winner.badge : (winner.segment && winner.segment.image ? winner.segment.image : 
    (winner.category && winner.category.image ? winner.category.image : null));
  
  return (
    <React.Fragment>
        <div className="flex flex-col bg-white border-1 border-slate-600 box-border rounded-md shadow-md">
          <div className="relative w-full overflow-hidden self-start">
              <img className="w-full aspect-[3/2] object-cover rounded-t" src={winner.image ? (urlFor(winner.image).format('webp')).width(492).fit('max') : ""} loading="lazy" />
              <div className="">
                  <div className="py-3 px-4 bg-[#414244]">
                      <div className="flex flex-row justify-between items-center gap-x-4">
                          <div className="flex-grow text-sm font-bold text-white leading-normal">{awardTitle}</div>
                          <div className="flex-none grid place-items-center w-12 h-12 bg-white rounded-full">
                              <img className="h-6 mx-auto" src={urlFor(badge).format('webp').height(96)} alt={winner.title} />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="grid grid-cols-1 p-4">
              <Paragraph className="text-lg font-extrabold leading-loose" ellipsis={ ellipsis ? { rows: 1, expandable: false,} : false }>{winner.title}</Paragraph>
              <Paragraph className="leading-normal" ellipsis={ ellipsis ? { rows: 2, expandable: false,} : false }>{winner.description ? winner.description : (winner.article ? winner.article.excerpt : null)}</Paragraph>
              {winner.article && 
              <Button className="mt-4" style={{ paddingTop: "2rem", paddingBottom: "2rem", lineHeight: "2rem" }} size="small" href={urlForArticle(winner.article)} target="_blank" type="primary" danger block>
                  Read article
              </Button>
              }
          </div>
        </div>
    </React.Fragment>
  );
};

export default COTY2024WinnerCard;